import { EShopCategory } from '@r1-frontend/api-domru/api-content/v1/shop/items/requestDto';

import { BaseAnalytics } from '@r1-frontend/analytics/dataLayerPush';

type TDeliveryType = 'russianPost' | 'serviceEngineerDelivery' | 'serviceEngineerDeliveryAndSetup';

export interface IBuildFullBuyEquipLabelParams {
    equipmentTitle: string,
    category: string,
    leasing: number,
    deliveryType?: TDeliveryType,
    cost?: number,
    testDrive?: number,
}
class FullBuyEquipAnalyticsBase extends BaseAnalytics {
    category = 'full_buy_equip';

    private equipmentCategoryMap: Record<string, string> = {
        [EShopCategory.Routers]:'router',
        [EShopCategory.YandexStation]: 'yandex-stanciya',
        [EShopCategory.YandexStationLite]: 'yandex-stanciya',
        [EShopCategory.Decoders]: 'tv',
    };

    private deliveryLabelMap: Record<TDeliveryType, string> = {
        russianPost: 'post',
        serviceEngineerDelivery: 'service',
        serviceEngineerDeliveryAndSetup: 'service',
    };

    constructor() {
        super();
    }

    buildDataLayerLabel(params: IBuildFullBuyEquipLabelParams): string {
        const  { equipmentTitle, category: equipmentCategory, leasing, deliveryType, cost, testDrive } = params;
        const purchaseType = leasing > 0 ? `Рассрочка (${leasing} мес.)` : 'В собственность';
        return `delivery:${deliveryType ? this.deliveryLabelMap[deliveryType] : 'not_selected'}|category:${this.equipmentCategoryMap[equipmentCategory] ?? ''}|name:${equipmentTitle}|payment:${purchaseType}${testDrive ? ' в тест-драйв' : ''}|cost:${cost}`;
    }

    enterFio(params: IBuildFullBuyEquipLabelParams) {
        const label = this.buildDataLayerLabel(params);
        this.send('enter_fio', label);
    }

    enterPhoneNumber(label: string) {
        this.send('enter_phone_number', label);
    }

    clickChangeContact(label: string) {
        this.send('click_change_contact', label);
    }

    clickChangeAddress(label: string) {
        this.send('click_address_change', label);
    }

    choosePurchaseType(label: string) {
        this.send('choose_type_purchase', label);
    }

    clickOrderDetails(params: IBuildFullBuyEquipLabelParams) {
        const label = this.buildDataLayerLabel(params);
        this.send('clicked_to_order_detail', label);
    }

    clickToBanner(label: string) {
        this.send('clicked_to_baner', label);
    }

    clickBurgerButton(label: string) {
        this.send('click_burger_bnt', label);
    }

    chooseDeliveryAddress(label: string) {
        this.send('click_choose_delivery_address', label);
    }

    contactConfirmSuccess(label: string) {
        this.send('contact_confirm_success', label);
    }

    chooseDeliveryAddressSuccess(label: string) {
        this.send('choose_delivery_address_success', label);
    }

    clickCreateRequest(label: string) {
        this.send('click_to_create_request', label);
    }

    createRequestSuccess(label: string) {
        this.send('create_request_success', label);
    }

    createRequestError(label: string) {
        this.send('create_request_error', label);
    }

    clickedToOrder(params: IBuildFullBuyEquipLabelParams) {
        const label = this.buildDataLayerLabel(params);
        this.send('clicked_to_order', label);
    }

    applicationForm(label: string) {
        this.send('application_form', label);
    }
}
const fullBuyEquipAnalyticsBase = new FullBuyEquipAnalyticsBase();

export {
    FullBuyEquipAnalyticsBase,
    fullBuyEquipAnalyticsBase,
};

